import { INSTANCELIST } from './API.js'

export const getEvents = ({ queryKey }) =>
  new Promise((resolve, reject) => {
    const { sort, range, filter, tabFilter } = queryKey[1]

    INSTANCELIST({
      method: 'get',
      url: '/customer-events',
      headers: {
        Authorization: `Bearer ${localStorage.getItem('token')}`,
      },
      params: {
        sort: JSON.stringify(sort),
        range: JSON.stringify(range),
        filter: JSON.stringify(filter),
        populate: 'customer',
        ...tabFilter,
      },
    })
      .then(resolve)
      .catch(reject)
  })

export const createEvent = (data) =>
  new Promise((resolve, reject) => {
    INSTANCELIST({
      method: 'post',
      url: '/customer-events',
      headers: {
        Authorization: `Bearer ${localStorage.getItem('token')}`,
      },
      data,
    })
      .then(resolve)
      .catch(reject)
  })

export const updateEvent = (id, data) =>
  new Promise((resolve, reject) => {
    INSTANCELIST({
      method: 'put',
      url: `/customer-events/${id}`,
      headers: {
        Authorization: `Bearer ${localStorage.getItem('token')}`,
      },
      data,
    })
      .then(resolve)
      .catch(reject)
  })
